module.exports = __webpack_public_path__ + "img/bank_account_border.5fc7b096.svg";